"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACChipGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ACChip_1 = require("./ACChip");
var ACChipGroup = function (_a) {
    var node = _a.node, executeEventHandlers = _a.executeEventHandlers;
    var _b = node.colors, colors = _b === void 0 ? {} : _b, _c = node.containerClassName, containerClassName = _c === void 0 ? '' : _c, _d = node.className, className = _d === void 0 ? '' : _d, _e = node.color, color = _e === void 0 ? 'default' : _e, _f = node.items, items = _f === void 0 ? [] : _f;
    var itemNode = { colors: colors, color: color, className: className };
    return ((0, jsx_runtime_1.jsx)("div", { className: containerClassName, children: items.map(function (item) { return ((0, jsx_runtime_1.jsx)(ACChip_1.ACChip, { node: __assign(__assign({}, itemNode), { name: item === null || item === void 0 ? void 0 : item.name, label: item === null || item === void 0 ? void 0 : item.label }), executeEventHandlers: executeEventHandlers }, "".concat(item.name))); }) }));
};
exports.ACChipGroup = ACChipGroup;
